<nb-radio-group [(ngModel)]="option">
    <nb-radio
      *ngFor="let option of options"
      [value]="option"
      (valueChange)="onChange($event)">
      {{ option.label }}
    </nb-radio>
  </nb-radio-group>

 
